<template>
  <div class="h-screen">
    <a class="fixed bottom-10 right-14 z-40 cursor-pointer chatBotShadow" @click="onOpenChatBot">
      <img src="../assets/images/chat_bot.png" alt="Chat" />
    </a>
    <NavBar v-if="pageLoaded" />
    <div
      class="h-fit xl:h-full pl-0 transition-[padding] duration-[500ms]"
      :class="{
        'pl-0': !commonStore.isHome && !commonStore.isError && !commonStore.isAuth,
        'xl:!pl-[270px]': !commonStore.isHome && !commonStore.isAuth && !commonStore.isError && commonStore.openSide,
        // 'px-0 pt-[80px]': commonStore.isHome,
        '!pt-0': commonStore.isAuth,
      }"
    >
      <transition appear name="fade" mode="out-in">
        <Nuxt
          :class="{
            'pt-8 px-5 xl:px-10 pb-[50px] xl:pb-[100px] mlandscape:pb-[80px]': !commonStore.isHome,
            'overflow-hidden h-[100vh] xl:overflow-visible xl:h-unset': commonStore.openSide && !commonStore.isHome,
          }"
        />
      </transition>
    </div>
  </div>
</template>

<script>
import { useCommonStore } from '@/store';
import NavBar from '../components/NavBar.vue';
import '@/plugins/vee-validation';

export default {
  name: 'DefaultPage',
  components: {
    NavBar,
  },
  data() {
    return {
      commonStore: useCommonStore(),
      title: this.$i18n.locale === 'en' ? 'Gooroomee Oligo | Self-Study Management System ' : '구루미 올리고ㅤ|ㅤ우리만을 위한 No.1 캠스터디 서비스',
    };
  },
  head() {
    return {
      htmlAttrs: {
        lang: this.$i18n.locale,
      },
      title: this.title,
    };
  },
  computed: {
    pageLoaded() {
      return this.commonStore.pageLoaded;
    },
  },
  watch: {
    '$i18n.locale': {
      handler() {
        setTimeout(() => {
          this.title = this.$i18n.locale === 'en' ? 'Gooroomee Oligo | Self-Study Management System ' : '구루미 올리고ㅤ|ㅤ우리만을 위한 No.1 캠스터디 서비스';
        }, 300);
      },
      deep: true,
    },
  },
  mounted() {
    const runTwc = () => {
      window.Twc('init', {
        brandKey: "MUxOPwt-6RJvxjfghABUmA",
        channelType: "scenario",
        scenarioId: "MzM1Ng==",
        buttonOption: {
          showLauncher: false,
          bottom: 120,
          zIndex: 999
        }
      })
    }
    (function () {
      function l() {
        const s = document.createElement("script");
        s.type = "text/javascript";
        s.async = true;
        s.src = "https://public-common-sdk.s3.ap-northeast-2.amazonaws.com/sdk/cloud/Twc.plugin.js";
        const x = document.getElementsByTagName("script")[0];
        if (x.parentNode) {
          x.parentNode.insertBefore(s, x);
          s.addEventListener('load', runTwc)
        }
      }
      l()
    })();
  },
  methods: {
    onOpenChatBot(){
      window.Twc.Chat.open()
    }
  }
};
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.3s;
}
.fade-enter,
.fade-leave-active {
  opacity: 0;
}
.chatBotShadow{
  img{
    width: 56px;
    height: 56px;
    border-radius: 50%;
    box-shadow: rgba(255, 255, 255, 0.2) 0px 0px 0px 1px inset, rgba(0, 0, 0, 0.1) 0px 4px 6px, rgba(0, 0, 0, 0.15) 0px 8px 30px;
  }
}
</style>
